const endpoint = {
  auth: {
    checkVersion: appVersion => !!appVersion && `auth/control/${appVersion}`,
    forgotPassword: `auth/forgot`,
    resetPassword: `auth/reset`,
    confirmProfile: `auth/confirm`,
    confirmProfileResend: `auth/confirm/resend`,
    signUp: `auth/signup`,
    registerToken: `auth/token`,
    removeToken: `auth/token/remove`,
    sendActivation: `auth/activation`,
  },
  cache: {
    totalDelete: `cache/delete`
  },
  media: {
    upload: `media/upload`,
    uploadAudio: `media/upload-audio`,
    delete: `media/delete`,
  },
  users: {
    new: `auth/signup`,
    linkStudent: `users/linkstudent`,
    update: `users/`,
    list: `users/list`,
    single: userID => !!userID && `users/${userID}`,
    singleForSchool: userID => !!userID && `users/origin/${userID}`,
    communications: {
      list: () => `communications/list`,
      single: commId => !!commId && `communications/${commId}`,
      markAs: commId => !!commId && `communications/marks/${commId}`,
    },
  },
  parent: {
    childrenList: parentID => !!parentID && `users/${parentID}/children`,
  },
  courses: {
    new: `courses/new`,
    update: `courses/`,
    list: `courses/list`,
    single: courseID => !!courseID && `courses/${courseID}`,
    // Get Course Attendances by ID
    attendances: courseID => !!courseID && `courses/${courseID}/attendance`,
    // Get Course Absences by ID
    absences: courseID => !!courseID && `courses/${courseID}/absences`,
    teacher: {
      list: treacherID => !!treacherID && `courses/teacher/${treacherID}`, // post
      single: courseID => !!courseID && `courses/for-teacher/${courseID}`, // post
      //Get Courses Attendance by Teacher ID
      attendancesList: teacherID => !!teacherID && `courses/teacher/${teacherID}/attendance`, // post
    },
    parent: {
      list: () => `courses/students`, // get
      single: courseID => !!courseID && `courses/${courseID}`,
      childrenAttendances: () => `courses/students/attendance`, // post
    },
  },
  attendances: {
    new: `attendances/new`,
    update: `attendances/`,
    list: `attendances/list`,
    single: attendanceID => !!attendanceID && `attendances/${attendanceID}`,
  },
  absences: {
    update: `absence/`, // patch
    new: `absence/new`, // post
    updateStatus: `absence/status`, // patch
    archive: `absence/archive`, // patch
    single: absID => !!absID && `absence/${absID}`, // get
    listForParent: childID => !!childID && `absence/student/${childID}`, // get
    parent: {
      list: childID => !!childID && `absence/student/${childID}`, // get
    },
    teacher: {
      list: teacherID => !!teacherID && `absence/list/teacher/${teacherID}`, // get
    },
  },
  students: {
    new: `students/new/`,
    update: `students/`,
    list: `students/list`,
    single: stdID => !!stdID && `students/${stdID}`,
    export: `students/export`,
    validation: `students/validation`,
  },
  notifications: {
    new: `notifications/new`,
    update: `notifications/`,
    push: `notifications/push`,
    delete: `notifications/delete`,
    list: (userId, limit, page) =>
      !!userId && `notifications/user/${userId}/${limit}/${page}`,
    parent: {
      notRead: (parentID, childID) =>
        !!parentID &&
        !!childID &&
        `notifications/parent/${parentID}/child/${childID}/notRead`,
      notReadAll: parentID =>
        !!parentID && `notifications/parent/${parentID}/children/notRead`,
    },
    teacher: {
      notRead: (userID, schoolKey) =>
        !!userID &&
        `notifications/teacher/${userID}/school/${schoolKey}/notRead`,
      notReadAll: userID =>
        !!userID && `notifications/teacher/${userID}/schools/notRead`,
    },
  },
  communications: {
    types: `communications/types`,
    remind: commId => !!commId && `communications/remind/${commId}`,
    parent: {
      list: (parentID, childID) =>
        !!parentID &&
        !!childID &&
        `communications/parent/${parentID}/child/${childID}`,
      single: ID => !!ID && `communications/response/${ID}`,
      update: (ID, childID) =>
        !!ID && !!childID && `communications/response/${ID}/student/${childID}`,
      new: (parentID, childID) =>
        !!parentID &&
        !!childID &&
        `communications/parent/${parentID}/child/${childID}/new`,
    },
    teacher: {
      list: userID => !!userID && `communications/user/${userID}`,
      single: ID => !!ID && `communications/response/${ID}`,
      update: (ID, role = "teacher") =>
        !!ID && !!role && `communications/response/${ID}/role/${role}`,
    },
    audiences: {
      new: commId => !!commId && `audiences/new/${commId}`,
      single: commId => !!commId && `communications/audience/${commId}`,
      force: commId => !!commId && `communications/audienceForce/${commId}`,
      update: commId => !!commId && `communications/audience/${commId}`,
    },
  },
  discussions: {
    single: discussionId => !!discussionId && `discussions/${discussionId}`,
    readersMarks: discussionId =>
      !!discussionId && `discussions/readers/${discussionId}`,
    messages: {
      new: `messages/new`,
      list: commId => !!commId && `discussions/messages/${commId}`,
    },
  },
};

export default endpoint;
